let normal = {
    'v_index_PocketCash': 'PocketCash',
    'v_index_homepage': 'home page',
    'v_index_Product_introduction': 'Product introduction',
    'v_index_About_us': 'About us',
    'v_index_con1_tit1': 'Maramihang mga paraan ng pag-withdraw',
    'v_index_con1_tit2': 'Kinakailangan lamang ang APP application',
    'v_index_con1_tit3': 'Kagustuhan interes',
    'v_index_con1_txt1': 'Ang pinakamabilis na 30 minuto upang makarating',
    'v_index_con1_txt2': 'Simple na operasyon at mabilis na pagsusuri',
    'v_index_con1_txt3': '36% mas mababa kaysa sa mga katulad na produkto',
    'v_index_con2_tit': 'Madaling tatlong hakbang',
    'v_index_con2_titdetail': 'Ang pinakamabilis na 30 minuto upang makarating',
    'v_index_con2_con1': 'Pag-login sa pag-login',
    'v_index_con2_con21': 'Punan ang impormasyon',
    'v_index_con2_con22': 'Naghihintay ng pagsusuri',
    'v_index_con2_con31': 'Mag-apply para sa isang pautang',
    'v_index_con2_con32': 'Naghihintay para sa account',
    'v_index_con2_con4': 'Naaprubahan',
    'v_index_con3_tit1': 'Kailangan lang magbigay ng 4 na mga item',
    'v_index_con3_tit2': 'Ang orihinal na intelihente na teknolohiya sa pagkontrol ng ',
    'v_index_con3_tit3': 'May mga nangungunang pandaigdigang serbisyo sa pananalapi na teknolohiya',
    'v_index_con3_tit4': 'Real credit borrowing',
    'v_index_con3_con11': 'Rapid review    mataas na rate ng pass',
    'v_index_con3_con12': 'Hayaan ang higit pang mga gumagamit tamasahin ang mga serbisyo ng credit loan',
    'v_index_con3_con21': 'Ang pagbibigay ng mga serbisyo sa pananalapi ng mamimili sa lahat',
    'v_index_con3_con31': '7 * 24h pautang',
    'v_index_con3_con32': 'Pagkumpleto ng iyong sariling tugma sa mas mababa sa 1s',
    'v_index_con3_con33': 'Ang pinakamabilis na 30 minuto upang makarating',
    'v_index_con3_con41': 'Real credit borrowing',
    'v_index_con3_con42': 'Kumpletuhin ang lahat ng mga pagpapatakbo ng application sa app',
    'v_index_con4_tit': 'PocketCash ay isang high-tech na kompanya ng Internet finance na may malawak na karanasan.',
    'v_index_con4_con': 'Sa isang banda, sa pamamagitan ng mobile Internet at orihinal na intelihente na teknolohiya ng hangin na kontrol upang magbigay ng mga gumagamit sa pagsusuri ng kredito, sa isang banda na nagtutulak ng mga institusyong pinansyal, upang ang lahat ay makapagtatamasa ng mga serbisyo sa pananalapi ng mamimili.',
    'v_index_foot1': 'XXX P2P IT CO.LTD',
    'v_index_foot2': 'Company: Elending Lending Inc',
    'v_index_con0_detail1': 'Magbigay ng iba\'t ibang mga serbisyo ng kredito',
    'v_index_con0_detail2': 'Maghiram ng cash madali',
    'v_index_language': 'Filipino',
    'v_index_download': 'I-download',
    'v_index_downloaddetails': 'I-scan ang QR code, i-download ang PocketCash.',
}
export default normal


// WEBPACK FOOTER //
// ./src/language/config/tl_PH.js